/* @flow */
import * as React from 'react';

// Styles
import styles from './UpcomingBraindateCardDate.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { convertToDateTime } from 'src/shared/app/base/date/util/dateUtils';
import { getBraindateStartTime } from '@braindate/domain/lib/braindate/util';

// Types
import type { Braindate } from '@braindate/domain/lib/braindate/type';

const useStyles = createUseThemeStyles(styles);

type Props = {
  braindate: Braindate,
};

const UpcomingBraindateCardDate = ({ braindate }: Props) => {
  const classes = useStyles();

  const braindateStartTime = getBraindateStartTime(braindate);
  if (!braindateStartTime) return null;

  const startTime = convertToDateTime(braindateStartTime);
  const date = startTime.toFormat('dd LLL');
  const time = startTime.toFormat('hh:mm a');

  return (
    <div className={classes.root}>
      <p className={classes.date}>{date}</p>
      <p className={classes.time}>{time}</p>
    </div>
  );
};

export default React.memo<Props>(UpcomingBraindateCardDate);
